import React from "react";
import "../scss/Logo.scss";
export default function Logo() {
  return (
    <div className="logo__container">
      <div className="logo__text">cctimesheet</div>
    </div>
  );
}
